import React, { useCallback } from 'react'
import { Dropdown } from '@scentregroup/ui'

enum ItemsPerPageOption {
  SHOW24 = 24,
  SHOW48 = 48,
  SHOW96 = 96,
  SHOW120 = 120,
}

const ITEMS_PER_PAGE_DROPDOWN_OPTIONS: { label: string; value: number }[] = [
  { label: 'Show: 24', value: ItemsPerPageOption.SHOW24 },
  { label: 'Show: 48', value: ItemsPerPageOption.SHOW48 },
  { label: 'Show: 96', value: ItemsPerPageOption.SHOW96 },
  { label: 'Show: 120', value: ItemsPerPageOption.SHOW120 },
]

interface IItemsPerPageDropdownProps {
  /** Value selected */
  value: number
  /** On change option callback */
  onChange: (option: number) => void
  onClick?: () => void
}

/** Dropdown widget for selecting how many items per page should be displayed */
const ItemsPerPageDropdown: React.FunctionComponent<
  React.PropsWithChildren<IItemsPerPageDropdownProps>
> = ({ onChange, value, onClick }) => {
  const onChangeDropdown = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>): void => {
      const numValue = parseInt(e.target.value, 10)
      onChange(numValue)
    },
    [onChange]
  )

  let val = value
  // If the value passed as a prop is not valid, default to 24
  if (!Object.values(ItemsPerPageOption).includes(value)) {
    val = ItemsPerPageOption.SHOW24
  }

  return (
    <Dropdown
      id="items-per-page"
      options={ITEMS_PER_PAGE_DROPDOWN_OPTIONS}
      value={val}
      onChange={onChangeDropdown}
      size="SMALL"
      onClick={onClick}
    />
  )
}

export default ItemsPerPageDropdown
